import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import type { SellerRankingEntry } from '@/types/dashboard'

export function SellerRanking({
  sellerRanking,
}: {
  sellerRanking: SellerRankingEntry[]
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Ranking de Vendedores</CardTitle>
        <CardDescription>Vendas no mês atual</CardDescription>
      </CardHeader>
      {sellerRanking.length === 0 ? (
        <div className="text-muted-foreground px-6 pb-6 text-sm">
          Nenhuma venda registrada neste mês.
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Vendedor</TableHead>
              <TableHead className="text-right">Vendas</TableHead>
              <TableHead className="text-right">Última Venda</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sellerRanking.map((seller) => (
              <TableRow key={seller.id}>
                <TableCell className="font-medium">{seller.name}</TableCell>
                <TableCell className="text-right">
                  {seller.salesCount}
                </TableCell>
                <TableCell className="text-muted-foreground text-right">
                  {seller.lastSaleAt
                    ? new Date(seller.lastSaleAt).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                      })
                    : '—'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  )
}
